module.exports = __webpack_public_path__ + "static/media/18ECA3.18bfa167.jpg";